import classNames from 'clsx';
import { h1, h2, h3, h4, h5, type HeaderVariants } from './Headlines.css';

type HeaderProps = {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
} & HeaderVariants;

export const H1 = ({
  children,
  className,
  style,
  as = 'h1',
  ...props
}: HeaderProps) => {
  const Tag = as ?? 'h1';
  return (
    <Tag className={classNames([h1({ ...props }), className])} style={style}>
      {children}
    </Tag>
  );
};

export const H2 = ({
  children,
  className,
  style,
  as = 'h2',
  ...props
}: HeaderProps) => {
  const Tag = as ?? 'h2';
  return (
    <Tag className={classNames([h2({ ...props }), className])} style={style}>
      {children}
    </Tag>
  );
};

export const H3 = ({
  children,
  className,
  style,
  as = 'h3',
  ...props
}: HeaderProps) => {
  const Tag = as ?? 'h3';
  return (
    <Tag className={classNames([h3({ ...props }), className])} style={style}>
      {children}
    </Tag>
  );
};

export const H4 = ({
  children,
  className,
  style,
  as = 'h4',
  ...props
}: HeaderProps) => {
  const Tag = as ?? 'h4';
  return (
    <Tag className={classNames([h4({ ...props }), className])} style={style}>
      {children}
    </Tag>
  );
};

export const H5 = ({
  children,
  className,
  style,
  as = 'h5',
  ...props
}: HeaderProps) => {
  const Tag = as ?? 'h5';
  return (
    <Tag className={classNames([h5({ ...props }), className])} style={style}>
      {children}
    </Tag>
  );
};
